import React from 'react'
import { useEffect, useState } from 'react';

const assetsPath = document.querySelector('meta[name="assets-path"]').content;

export default function App() {
  return (
    <MatchmymareComponent />
  )
}


function MatchmymareComponent() {
  const [currentActive, setCurrentActive] = useState(1);
  const [selections, setSelections] = useState([]);
  const [results, setResults] = useState([]);
  console.log('currentActive', currentActive, 'selections', selections);

  const filterItems = [
    { label: "Ability", id: "ability" },
    { label: "Quality", id: "quality" },
    { label: "Size", id: "size" },
    { label: "Gallop", id: "gallop" },
    { label: "Blood", id: "blood" },
    { label: "Technique", id: "technique" },
    { label: "Balance", id: "balance" },
    { label: "Rideability", id: "rideability" },
  ];
  
  useEffect(() => {
    if (currentActive == 4) {
      if (selections.length !== 3) {
        throw new Error('Please select 3 unique properties');
      }

      const _ = async () => {
        const apiUrl = '/wp-json/stallion/v1/configurator';
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(selections),
        });
        const data = await response.json();
        console.log('DATA', data);
        setResults(data.stallions);
      }
      _();
    }
  }, [currentActive, selections]);

  const ifExist = (item) => selections.some((val) => val === item.id);

  const handleProgressbar = (val) => {
    setCurrentActive(val);
    setSelections(selections.slice(0, val - 1));
  };

  const handleNextButton = (item) => {
    setCurrentActive((val) => val + 1);
  };

  const handlePreviousButton = () => {
    if (selections.length == currentActive) {
      setSelections(selections.slice(0, -1));
    }
    setCurrentActive((val) => val - 1);
  };

  return (
    <main className="flex my-10 max-w-[80rem] px-5 mx-auto">
      <div className="w-full text-center">
      <ProgressBar currentActive={currentActive} handleProgressbar={handleProgressbar} />
      {currentActive < 4 && (
        <>
          <div className="grid gap-5 my-16 grid-cols-2 md:grid-cols-4">
            {filterItems.map((item) =>
              ifExist(item) && selections[currentActive - 1] != item.id ? (
                <div
                  key={item.id}
                  className="text-2xl px-5 py-6 lg:p-12 bg-[#F7F5F5] text-gray-300 cursor-default border border-[#F7F5F5]"
                >
                  <p className='font-serif text-lg md:text-2xl'>{item.label}</p>
                </div>
              ) : (
                <div
                  onClick={() => setSelections((selections) => {
                    if (selections[currentActive - 1] === item.id) {
                      return selections.filter((val) => val !== item.id);
                    } else if (selections[currentActive - 1]) {
                      return selections.map((val, index) => (index === currentActive - 1 ? item.id : val));
                    } else {
                      return [...selections, item.id];
                    }
                  })}
                  key={item.id}
                  id={item.id}
                  className={`text-2xl px-5 py-6 lg:p-12 border relative cursor-pointer bg-[#F7F5F5] ${
                    selections.includes(item.id) ? "border-theme" : "border-transparent"
                  }`}
                >
                  <p className={`${selections[currentActive - 1] === item.id ? "text-[#000000] font-serif text-lg md:text-2xl" : "text-black font-serif text-lg md:text-2xl"}`}>
                    {item.label}
                  </p>
                  {selections[currentActive - 1] === item.id && (
                    <div className="absolute w-8 h-8 bg-theme flex justify-center items-center rounded-full z-10 top-2 right-2 ">
                      <img src={`${assetsPath}/images/tick.svg`} className="w-3" />
                    </div>
                  )}
                </div>
              )
            )}
          </div>
          <div className="w-full text-sm flex justify-between">
            {currentActive > 1 && (
              <button
                onClick={handlePreviousButton}
                className="uppercase tracking-widest flex gap-2.5 items-center text-[#000000] px-2 py-2 border-b border-theme"
              >
                <img src={`${assetsPath}/images/arrow-right-blue.svg`} className="w-5 rotate-180" />
                Previous
              </button>
            )}

            <button
              disabled={!selections[currentActive - 1]}
              onClick={() => handleNextButton()}
              className={`uppercase tracking-widest py-3 ml-auto px-5 flex gap-2.5 items-center ${
                !!selections[currentActive - 1] ? "bg-theme hover-bg-theme text-[#ffffff]" : "bg-[#C9CFD2] text-[#ffffff]"
              }`}
            >
              <p className='font-serif text-2xl sm:text-3xl'>Next</p>
              {!!selections[currentActive - 1] && <img src={`${assetsPath}/images/arrow-right.svg`} className="w-5" />}
              {!selections[currentActive - 1] && <img src={`${assetsPath}/images/arrow-right-white.svg`} className="w-5" />}
            </button>
          </div>
        </>
      )}
      {currentActive === 4 && (
        <>
          <div className="grid my-24 grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-x-4 md:gap-x-6 gap-y-10 md:gap-y-12">
            {results.map((item) => (
              <HorseCard key={item.id} horse={item} />
            ))}
          </div>
        </>
      )}
    </div>
    </main>
  );
}

export function HorseCard({ horse }) {
  return (
    <a
      href={horse.link}
      className="mx-auto text-white uppercase h-[500px] relative hover:scale-105 bg-gray-400 transition-transform duration-500 w-[350px] mx-[15px] overflow-hidden"
      target="_blank"
    >
      <img
        src={horse.image}
        alt={horse.title}
        className="w-full h-full object-cover"
      />
      <div className="absolute w-full left-0 bottom-0 bg-gradient-to-t from-[#000000] pt-16 pb-7 space-y-2 px-4 text-center">
        <p className="typo-medium text-xs tracking-wider">
          {horse.main_category}
        </p>
        <h2 className="text-xl typo-medium font-serif">{horse.title}</h2>
      </div>
    </a>
  );
}

export function ProgressBar({ currentActive = 1, handleProgressbar }) {
  const progressItem = [
    { tagLine: "Which characteristic is the most important?" },
    { tagLine: "Which characteristic is the second-most important?" },
    { tagLine: "Which characteristic is the third-most important?" },
    { tagLine: "Your matching stallion results" },
  ];

  const handleClickBars = (id) => {
    if (id < currentActive) {
      handleProgressbar(id);
    }
  };

  return (
    <div>
      <div className="border-b w-full">
        <div className="flex justify-center text-sm sm:text-base gap-2.5 items-center max-w-[50rem] py-10 w-full mx-auto">
          {[1, 2, 3, 4].map((step, index) => (
            <div key={index} onClick={() => handleClickBars(step)} className="cursor-pointer">
              <button className="flex gap-2 items-center">
                <span
                  className={`flex justify-center items-center text-xs md:text-sm text-white w-6 h-6 rounded-full ${
                    currentActive >= step ? "bg-theme" : "bg-[#C9CFD2] text-[#E8F4FC]"
                  }`}
                >
                  {step}
                </span>
                <span className={`${currentActive >= step ? "text-[#000000]" : "text-[#C9D6E6]"} ${currentActive === step ? "block" : "hidden md:block"}`}>
                  {step < 4 ? `Characteristic ${step}` : "Result"}
                </span>
                {step < 4 && <hr className={`${currentActive >= step ? "border-theme" : "border-[#C9D6E6]"} w-[2.5rem]`} />}
              </button>
            </div>
          ))}
        </div>
      </div>
      <h1 className="font-serif text-2xl sm:text-3xl mt-16 mb-6">{progressItem[currentActive - 1].tagLine}</h1>
      {currentActive !== 4 && (
        <p className="text-center text-xl">
          Select one of the properties below that are most important to you in your search for a stallion.
        </p>
      )}
      {currentActive === 4 && (
        <p className="text-center text-xl">Based on your choices, we recommend one of the following stallions.</p>
      )}
    </div>
  );
}
